// extracted by mini-css-extract-plugin
export default {"activity_block__timeline":"styles_activity_block__timeline__gKK49","spin":"styles_spin__jKR5+"};